import React, { memo } from "react"

import { Loader } from "~/ui-rtk/components/ui/common"
import { useConnect } from "./connect"
import { useConnect as useConnectorConnect } from "../ConnectorStatus/connect"
import { formatDate } from "../ConnectorStatus/utils"
import { defaultImages } from "~/ui-rtk/shared/constants/image-paths.contants"
import { uniqueId } from "lodash"
import { renderStatusIcon } from "../../utils"

type TAccountInfoProps = {
  confirmedAt?: string
  companyConnectorId: string
}

const AccountInfo: React.FC<TAccountInfoProps> = ({
  confirmedAt,
  companyConnectorId,
}) => {
  const { accountInfo, isLoading } = useConnect(companyConnectorId)

  const { connectorInfo } = useConnectorConnect(companyConnectorId)

  if (isLoading) {
    // TODO: Add lazy loader
    return <Loader />
  }

  const isAccountInfo =
    Boolean(accountInfo?.accountName) && Boolean(accountInfo?.metric)

  return (
    <article className="max-w-89 w-full mb-4">
      {isAccountInfo && accountInfo ? (
        <>
          <div className="mb-5">
            <div className="flex justify-start gap-4">
              <img
                src={accountInfo?.avatarUrl || defaultImages.noImage}
                alt={`${accountInfo.accountName} Icon`}
                width={42}
                height={42}
              />
              <div className="flex flex-col items-start">
                <b>{accountInfo.accountName}</b>
                <p>{accountInfo.metric}</p>
              </div>
            </div>
          </div>
        </>
      ) : null}

      {connectorInfo ? (
        <section className="gap-4">
          {connectorInfo.warnings && connectorInfo.warnings.length > 0 ? (
            <div className="flex flex-col gap-2 text-left mb-2">
              <div className="flex items-center gap-2">
                {renderStatusIcon("warning")}
                <p>Warnings:</p>
              </div>
              <ul className="ml-4">
                {connectorInfo.warnings.map(warning => (
                  <li
                    key={uniqueId()}
                    className="text-3.5 text-white flex items-center gap-2"
                  >
                    <p>— {warning.message}</p>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
          <p className="flex justify-start gap-2">
            {confirmedAt
              ? `Confirmed: ${formatDate(confirmedAt)}`
              : "Unconfirmed"}{" "}
          </p>

          <p className="flex justify-start">
            Last Update:{" "}
            {connectorInfo.lastSuccessfulSyncDate
              ? formatDate(connectorInfo.lastSuccessfulSyncDate)
              : "Pending"}
          </p>
        </section>
      ) : (
        <p>Failed to load connection details</p>
      )}
    </article>
  )
}

export default memo(AccountInfo)
